export default __webpack_public_path__ + "static/media/M37.938ed2c7.svg";